<p-tabMenu [model]="menuItems"> </p-tabMenu>

@if (
  activeMenuItem &&
    activeMenuItem.id &&
    store.filterByType(asWorkspaceTypeKey(activeMenuItem.id));
  as workspaces
) {
  <p-table
    #workspaceTable
    [globalFilterFields]="['name']"
    [loading]="loading"
    [value]="workspaces">
    <ng-template pTemplate="caption">
      <app-table-list-caption
        [searchWord]="searchWord"
        (clearTable)="clear(workspaceTable)"
        (search)="
          workspaceTable.filterGlobal($event, 'contains')
        "></app-table-list-caption>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Aktionen</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-workspace>
      <tr>
        <td>{{ workspace.name }}</td>
        <td>
          <app-table-list-actions
            [item]="workspace"
            (confirm)="confirm($event, workspace, workspace.name)">
          </app-table-list-actions>
        </td>
      </tr>
    </ng-template>
  </p-table>
  @if (!workspaces.length) {
    <div role="alert" class="p-message p-message-info">
      <div class="p-message-wrapper">
        <span class="p-message-summary">Keine Einträge gefunden</span>
        <span class="p-message-detail"
          >Legen Sie Arbeitsbereiche an, um Rechte auf verschiedenen
          Inhalts-Gruppen zu verteilen.</span
        >
      </div>
    </div>
  }
}

<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-5'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
